import { render } from "./Footer.vue?vue&type=template&id=3017feb0&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=3017feb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3017feb0"

export default script